import { getEmailAvailability } from '../../selectors/member/get-email-availability';
export const loadLastValidatedEmail = async () => {
    const emailAvailabilityData = await getEmailAvailability();
    return emailAvailabilityData === null || emailAvailabilityData === void 0 ? void 0 : emailAvailabilityData.lastValidatedEmail;
};
